import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgWarningIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 100 100"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="#B80012"
      d="M43.303 12.11A4.21 4.21 0 0 1 46.952 10h5.987a4.21 4.21 0 0 1 3.648 2.11L95.33 79.397a4.21 4.21 0 0 1-.146 4.436l-2.861 4.292A4.21 4.21 0 0 1 88.818 90H11.072a4.21 4.21 0 0 1-3.504-1.875l-2.86-4.292a4.21 4.21 0 0 1-.146-4.436zm9.636 2.1h-5.987L8.21 81.499l2.86 4.291h77.747l2.862-4.291zm-5.1 46.316V35.263h4.211v25.263zm-1.052 6.316h6.316v6.316h-6.316z"
    />
  </svg>
)
export default SvgWarningIcon
